import FirstName from "@/app/components/common/actions/inputs-b/FirstName";
import LastName from "@/app/components/common/actions/inputs-b/LastName";
import { useEffect } from "react";
import type { UseFormSetValue, UseFormWatch } from "react-hook-form";

interface Props {
  watch: UseFormWatch<any>;
  setValue: UseFormSetValue<any>;
  personalInfo: any;
}

const UpdateuserName = ({ setValue, watch, personalInfo }: Props) => {
  // ............................... useEffect ................................
  useEffect(() => {
    if (personalInfo) {
      setValue("firstname", personalInfo.firstName ?? "");
      setValue("lastname", personalInfo.lastName ?? "");
    }
  }, [personalInfo, setValue]);

  return (
    <div className="grid grid-cols-12 gap-4">
      <div className="col-span-12">
        <FirstName
          label="First Name"
          value={watch("firstname")}
          onChange={(val) => setValue("firstname", val)}
        />
      </div>

      <div className="col-span-12">
        <LastName
          label="Last Name"
          value={watch("lastname")}
          onChange={(val) => setValue("lastname", val)}
        />
      </div>
    </div>
  );
};

export default UpdateuserName;
